import { redirectToLitlingoLogin } from 'actions';
import { GOOGLE_ICON } from 'constants/commonIcons';
import React from 'react';
import { useDispatch } from 'react-redux';

const SignInWithGoogleButton: React.FC = () => {
  const dispatch = useDispatch();

  const handleLoginClick = (): void => {
    dispatch(redirectToLitlingoLogin({ providerHint: 'google' }));
  };

  return (
    <button
      type="button"
      className="bg-litlingo-background flex justify-center items-center border border-litlingo-line w-full py-2 focus:outline-none"
      onClick={handleLoginClick}
    >
      <span className="mr-2">{GOOGLE_ICON}</span>
      <span className="text text--medium">
        Sign in with <b>Google</b>
      </span>
    </button>
  );
};

export default SignInWithGoogleButton;
